import { combineReducers } from "redux";
// slices
import kenoReducer from "../features/keno/kenoSlice";
import chipsReducer from "../features/chips/chipsSlice";
import authReducer from "../features/auth/authSlice";
import gameHistoryReducer from "../features/gameHistory/gameHistorySlice";
import storage from "redux-persist/lib/storage";
// ----------------------------------------------------------------------
const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
const rootReducer = combineReducers({
  keno: kenoReducer,
  chips: chipsReducer,
  auth: authReducer,
  gameHistory: gameHistoryReducer,
});

export { rootPersistConfig, rootReducer };
